<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "EmpfehlungList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Empfehlungsmanagement"
      new-button-name="Neue(s) Dokument/Information"
      :list-header="tableHeader"
      :category=12
      :event-to-call-options="{
        table: tableItems,
        showPath: 'Empfehlung',
        redirectPath: 'EmpfehlungEdit',
        categoryId: 12,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'empfehlungsmanagement'
      }"
   new-button-path="EmpfehlungNew"></CMSListCard>
</template>

<style scoped>

</style>
